import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

const FLAG = {
    USD: "🇺🇸",
    EUR: "🇪🇺",
    GBP: "🇬🇧",
    AED: "🇦🇪",
    SGD: "🇸🇬",
    JPY: "🇯🇵",
    AUD: "🇦🇺",
    CAD: "🇨🇦",
};

export default function ForexTicker() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const r = await api.get("/forex/rates");
                if (mounted) {
                    setData(r.data);
                    setErr(null);
                }
            } catch (e) {
                if (mounted) setErr("Rates unavailable");
                console.error("[ForexTicker] failed", e);
            }
        };
        load();
        // Refresh every 5 minutes (server caches for 10 min anyway)
        const t = setInterval(load, 5 * 60 * 1000);
        return () => {
            mounted = false;
            clearInterval(t);
        };
    }, []);

    if (err || !data || !data.items?.length) {
        return null;
    }

    // Duplicate items to make a seamless marquee loop
    const strip = [...data.items, ...data.items];

    return (
        <div
            className="mb-6 rounded-lg border border-stone-200 bg-white overflow-hidden"
            data-testid="forex-ticker"
        >
            <div className="flex items-center gap-3 px-4 py-2 border-b border-stone-100">
                <div className="w-6 h-6 rounded-md bg-stone-900 text-white flex items-center justify-center">
                    <TrendingUp size={12} />
                </div>
                <div className="eyebrow">Live Forex &middot; 1 unit = INR</div>
                <div className="ml-auto flex items-center gap-2 text-[11px] text-stone-500">
                    <span className="live-dot" />
                    {data.cached ? "cached" : "live"} &middot; {data.provider}
                </div>
            </div>
            <div className="fx-marquee-wrap">
                <div className="fx-marquee" data-testid="forex-marquee">
                    {strip.map((it, i) => (
                        <div
                            key={`${it.code}-${i}`}
                            className="fx-chip"
                            data-testid={i < data.items.length ? `fx-${it.code}` : undefined}
                        >
                            <span className="fx-flag" aria-hidden>
                                {FLAG[it.code] || "🌐"}
                            </span>
                            <span className="fx-code">{it.code}</span>
                            <span className="fx-val tabular-nums">
                                ₹{it.inr_per_unit.toLocaleString("en-IN", { maximumFractionDigits: 4 })}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
